import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const AddonEditor = ({ value = [], onChange }) => {
  const update = (i, patch) => onChange(value.map((a, j) => (j === i ? { ...a, ...patch } : a)));
  return (
    <div className="space-y-1.5" data-testid="addon-editor">
      {value.map((a, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            data-testid={`addon-label-${i}`}
            value={a.label}
            placeholder="Add-on (e.g. gun box)"
            onChange={(e) => update(i, { label: e.target.value })}
            className="h-8 text-sm"
          />
          <div className="flex items-center gap-1">
            <span className="text-xs text-muted-foreground">$</span>
            <Input
              type="number"
              data-testid={`addon-price-${i}`}
              value={a.price}
              onChange={(e) => update(i, { price: e.target.value })}
              className="h-8 w-24 text-sm"
            />
          </div>
          <Input
            data-testid={`addon-fit-${i}`}
            value={a.fit_widths || ""}
            placeholder="fits 62,70"
            title="Hull widths this add-on fits (inches). Blank = all."
            onChange={(e) => update(i, { fit_widths: e.target.value })}
            className="h-8 w-28 flex-shrink-0 text-xs"
          />
          <label className="flex items-center gap-1 whitespace-nowrap text-xs" title="Pre-selected for the customer">
            <input
              type="checkbox"
              checked={!!a.default}
              onChange={(e) => update(i, { default: e.target.checked })}
              className="h-3.5 w-3.5 accent-[#1B66C9]"
            />
            default
          </label>
          <button
            type="button"
            onClick={() => onChange(value.filter((_, j) => j !== i))}
            className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-secondary"
          >
            <Trash2 size={13} />
          </button>
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        size="sm"
        data-testid="addon-add"
        onClick={() => onChange([...value, { label: "", price: 0, default: false, fit_widths: "" }])}
        className="text-xs font-bold"
      >
        <Plus size={13} className="mr-1" /> Add add-on
      </Button>
    </div>
  );
};

export const normalizeAddons = (addons = []) =>
  addons
    .filter((a) => String(a.label).trim())
    .map((a) => ({ label: String(a.label).trim(), price: Number(a.price) || 0, default: !!a.default, fit_widths: String(a.fit_widths || "").trim() }));

export const normalizeVariants = (variants = []) =>
  variants
    .filter((g) => g.name.trim())
    .map((g) => ({
      name: g.name.trim(),
      fit_widths: String(g.fit_widths || "").trim(),
      multi: !!g.multi,
      options: g.options
        .filter((o) => String(o.label).trim())
        .map((o) => ({ label: String(o.label).trim(), price_delta: Number(o.price_delta) || 0, fit_widths: String(o.fit_widths || "").trim(), per_unit: !!o.per_unit })),
    }))
    .filter((g) => g.options.length);
